<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'xtgl_jsry_bmjg' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到部门机构</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 40%;">
					<el-form-item label="部门编号"><el-input placeholder="自动生成" :disabled="true"></el-input></el-form-item>
					<el-form-item label="部门名称"><el-input v-model="form.name"></el-input></el-form-item>
					<el-form-item label="部门领导">
						<el-select v-model="value1" multiple filterable allow-create default-first-option style="width: 90%;">
							<el-option v-for="item in manger" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="启用状态"><el-switch v-model="value"></el-switch></el-form-item>
					<el-form-item label="企业微信"><el-input v-model="form.qywx"></el-input></el-form-item>
					<el-form-item label="创建人"><el-input :placeholder="user.name" :disabled="true"></el-input></el-form-item>
				</div>
			</div>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
	</div>
</template>

<script>
import { mapState} from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			value:true,
			form:{
				name:'',
				qywx:'',
			},
			manger:[],
			value1:[],
			tor:0
		};
	},
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
	},
	mounted() {
		
		if(this.$route.params.data){
			this.form = this.$route.params.data
			this.value1.push(this.form.bmld.id)
			if(this.form.state == 1){
				this.value = true
			}else{
				this.value = false
			}
			this.tor = this.form.id
		}
		this.managers()
	},
	methods: {
		managers(){
			this.axios.get('/admin/managers/list', {
					token: true
				})
				.then(res => {
					this.manger = res.data.data
				})
		},
		//提交
		submit() {
			if(this.value == true){
				var a = 1
			}else{
				var a = 0
			}
			let e = {
				name:this.form.name,
				qywx:this.form.qywx,
				state:a,
				bmld:this.value1[0],
				cjr:this.user.id
			}
			
			if(this.tor == 0){
				this.axios.post('/admin/bumen', e, {
						token: true
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: '创建成功' //如果this.id存在,就是修改成功,否则就是发布成功
						});
						this.$router.push({
							name: 'xtgl_jsry_bmjg'
						});
					})
			}else{
				this.axios.post('/admin/bumen/' + this.tor, e, {
						token: true
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: '修改成功' //如果this.id存在,就是修改成功,否则就是发布成功
						});
						this.$router.push({
							name: 'xtgl_jsry_bmjg'
						});
					})
			}
		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
